<template>
  <div class="d-flex align-items-center flex-column">
    <AutoComplete
      v-if="ready"
      v-model="customerId"
      :placeholder="placeholder"
      class="full-width"
      :options="options"
      :name="name"
      :validation-errors="v$.$errors"
      :disabled="disabled"
      ignore-filter
      @search="handleSearch"
    />
  </div>
</template>

<script>
import debounce from "lodash/debounce";
import { mapActions } from "vuex";

import AutoComplete from "@/components/AutoComplete.vue";
import { isSearchableTerm } from "@/lib/customerSearchTerm";
import useVuelidate from "@vuelidate/core";

export default {
  components: {
    AutoComplete
  },
  props: {
    filterId: {
      type: [String, Number],
      default: null
    },
    name: {
      type: String,
      default: ""
    },
    modelValue: {
      type: [String, Number],
      default: null
    },
    placeholder: {
      type: String,
      default: "Search accounts..."
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  emits: ["update:modelValue"],
  setup() {
    return {
      v$: useVuelidate()
    };
  },
  data() {
    return {
      customers: [],
      customerId: null,
      selectedCustomer: null,
      ready: false
    };
  },
  computed: {
    options() {
      return this.filterOptions(this.customers, this.filterId);
    }
  },
  watch: {
    customerId(newValue, oldValue) {
      if (newValue !== oldValue) {
        this.$emit("update:modelValue", newValue);
        if (newValue) {
          this.fetchCustomerData();
        }
      }
    },
    modelValue(newValue, oldValue) {
      if (newValue !== oldValue) {
        this.customerId = newValue;
      }
    }
  },
  created() {
    if (this.modelValue) {
      this.customerId = this.modelValue;
    } else {
      this.ready = true;
    }
  },
  mounted() {
    if (this.customerId) {
      this.fetchCustomerData();
    }
  },
  methods: {
    ...mapActions(["lookupCustomer", "fetchUser"]),
    fetchCustomerData() {
      this.fetchUser({ id: this.customerId, returnOnly: true }).then((res) => {
        this.customers = [res.data];
        this.selectedCustomer = res.data;
        this.ready = true;
      });
    },
    filterOptions(options, id) {
      return options
        .filter((user) => user.id !== id)
        .map((user) => ({
          value: user.id,
          label: `${this.fullName(user)} | ${user.email}`
        }));
    },
    handleSearch: debounce(function (terms = "") {
      if (isSearchableTerm(terms)) {
        //lookup customers via api
        this.lookupCustomer({
          terms
        }).then((res) => {
          this.customers = res.data || [];
        });
      } else if (this.customers.length) {
        this.customers = [];
      }
    }, 300)
  }
};
</script>

<style lang="scss" scoped></style>
